<ul class="types">
  <div class="types__searchbar">
    <fa-icon [icon]="faMagnifyingGlass"></fa-icon>
    <input
      class="types__searchbar__search fs__sm"
      #searchQuery
      type="text"
      (input)="onSearchUpdated(searchQuery.value)"
      autocomplete="off"
      placeholder="Search"
    />
  </div>
  @for (option of items(); track option.type) {
    <li class="types__type" (click)="selectType(option.type)">
      <div class="types__type__action" [ngClass]="{ types__type__active: option.type === selected }">
        <fa-icon [icon]="option.icon"></fa-icon>
        <span class="types__type__name fs__sm fw__500">{{ option.text }}</span>
      </div>
    </li>
  }

  @if (items().length === 0) {
    <li class="types__type">
      <div class="types__type__action">
        <fa-icon [icon]="faXmark"></fa-icon>
        <span class="types__type__name fs__sm fw__500">No results</span>
      </div>
    </li>
  }
</ul>
